import type { ISerialize } from '@/objects/ISerialize';

export class SignalrShootingResultSubscribeParameters implements ISerialize {
    public EventID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { EventID?: number }) {
        this.EventID = values.EventID ?? 0;
    }

    public serialize(): string {
        return '{' + `"EventID": ${JSON.stringify(this.EventID)}` + '}';
    }

    /**
     * Creates an instance of SignalrShootingResultSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { EventID?: number }): SignalrShootingResultSubscribeParameters {
        return new SignalrShootingResultSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrShootingResultSubscribeParameters {
        return new SignalrShootingResultSubscribeParameters({ EventID: json.EventID });
    }

    /**
     * Creates an instance of SignalrShootingResultSubscribeParameters from another instance of SignalrShootingResultSubscribeParameters.
     * @param other The SignalrShootingResultSubscribeParameters you want to clone
     * @returns A cloned SignalrShootingResultSubscribeParameters
     */
    public static FromOther(other: SignalrShootingResultSubscribeParameters): SignalrShootingResultSubscribeParameters {
        return SignalrShootingResultSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrShootingResultSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrShootingResultSubscribeParameters';
}
